import type { EvalCase } from '@/services/eval-service';

export const GUIDED_TASK_TYPE = 'guided_grading_fidelity';

export type GuidedCaseMeta = {
  canvas_key?: string;
  slot?: string;
  expected_criteria_met?: boolean;
};

/**
 * @param {EvalCase} evalCase - a stored eval case
 * @returns {GuidedCaseMeta} the guided fields it carries, empty when it is not a guided case
 */
export function guidedMetaOf(evalCase: EvalCase | null): GuidedCaseMeta {
  if (!evalCase || evalCase.task_type !== GUIDED_TASK_TYPE) return {};
  const meta = evalCase.metadata as GuidedCaseMeta | undefined;
  return {
    canvas_key: meta?.canvas_key,
    slot: meta?.slot,
    expected_criteria_met: meta?.expected_criteria_met,
  };
}

/**
 * @param {GuidedCaseMeta} meta - the guided fields currently on the form
 * @returns {string[]} what is still missing before the case can be run
 */
export function guidedMissingFields(meta: GuidedCaseMeta): string[] {
  return [
    ['a canvas', meta.canvas_key],
    ['an element', meta.slot],
    ['the verdict a human reached', meta.expected_criteria_met === undefined ? '' : 'ok'],
  ]
    .filter(([, value]) => !value)
    .map(([label]) => label as string);
}
